module.exports = {"failed":"Login failed","success":"Login successful"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/en/auth.json
// module id = 243
// module chunks = 1